import { render, staticRenderFns } from "./PartExchangeVehicleComponent.vue?vue&type=template&id=15e90e15"
import script from "./PartExchangeVehicleComponent.vue?vue&type=script&lang=ts"
export * from "./PartExchangeVehicleComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports